
const tag_completion_on_click = (event, currentText: string, callback: (newValue:string) => void ) => {
    const target = event.target;
    if (target.classList.contains('tag')) {
        const text = '#' + target.innerHTML;
        var oldValue = currentText;
        let newValue = oldValue;
        if (oldValue && !oldValue.endsWith(' ')) {
            newValue += ' ';
        }
        newValue += text;
        callback(newValue);
        event.stopPropagation();
        event.preventDefault();
    }
};

export default tag_completion_on_click;
